module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Semibold--52984b3a4e09652a6feee711d5c169fd.52984b3a4e09652a6feee711d5c169fd.ttf";